// import MetaInfo from "../components/MetaInfo/MetaInfo";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";

const Layout = ({ children }) => {
  return (
    <>
      <div className="h-screen grid grid-rows-[max-content,1fr,max-content] pt-92px">
        <Navbar />
        {children}
        <Footer />
      </div>
    </>
  );
};

export default Layout;
